/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect, useRef, useState } from "react";
import "../../../assets/styles/custom-style.css";

import { useAuth } from "../../../auth";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import '@fortawesome/fontawesome-free/css/all.min.css';

import {
  getCategory,
  getCuisine,
  getReports,
  getType,
  getDish,
  getUser,
  getOrderStatus,
} from "../core/_requests";
import { useNavigate } from "react-router-dom";
import { UUID } from "crypto";
import { useDownloadExcel } from "react-export-table-to-excel";
import Pagination from "../../../component/Pagination";
import { useFormattedUtils } from "../../../component/dateUtils";
import './print.css';
import SearchInput from "../../../component/core/Searchinput";
interface Orders {
  primaryId: number;
  orderstatusId: number;
  uuid: string;
  orderId: string;
  chefId: string;
  userId: string;
  amount: number;
  tax: number;
  deliveryCharge: number;
  deliveryType: number;
  couponApplied: boolean;
  couponAmount: number | null;
  walletDiscount: number | null;
  deliveryPersonTips: number;
  chefTips: number;
  paymentMethod: string;
  netValue: number;
  orderDate: string;
  orderTime: string;
  totalAmount: number;
  orderstatus: {
    name: string;
  };
  chef: {
    name: string;
    currentlyAvailableStatus: boolean;
    email: string;
    phoneNumber: string | null;
    phoneNumber1: string | null;
    mobileNumber: string;
    mobileNumber1: string | null;
    location: string | null;
    licence: string | null;
    chefProfile: string | null;
    approvalStatus: boolean;
    address: string;
    city: string;
    state: string;
    country: string;
    zipCode: string;
    status: number;
    enableDisableStatus: boolean;
  };
  orderdetails: [
    {
      id: number;
      orderId: string;
      dishId: string;
      quantity: number;
      amount: number;
      status: number;
      createdAt: string;
      updatedAt: string;
      dish: {
        name: string;
        dishImage: string;
        price: number;
        cuisine: {
          name: string;
        };
        category: {
          name: string;
        };
        type: {
          name: string;
        };
        addons: [
          {
            id: number;
            name: string;
            quantity: number;
            price: number;
          }
        ];
      };
    }
  ];
  user: {
    id: number;
    uuid: string;
    userProfile: string;
    deviceId: string | null;
    token: string;
    verifyStatus: string | null;
    deviceType: string | null;
    deviceToken: string | null;
    loginType: string | null;
    name: string;
    email: string;
    latitude: string | null;
    longitude: string | null;
    contactNumber: string;
    plansId: string | null;
    planStartDate: string | null;
    planEndDate: string | null;
    planStatus: string | null;
    status: number;
    createdBy: string | null;
    updatedBy: string | null;
    createdAt: string;
    updatedAt: string;

    addressbooks: [
      {
        label: string;
        address1: string;
        address2: string;
        city: string;
        state: string;
        country: string;
        zipcode: any;
      }
    ];
  };
}
interface OrderStatusList {
  id: string | number | readonly string[] | undefined;
  uuid: UUID;
  name: string;
}

interface User {
  uuid: UUID;
  userName: string;
}
interface Type {
  uuid: UUID;
  name: string;
}
interface Dish {
  uuid: UUID;
  name: string;
}
interface Category {
  uuid: UUID;
  name: string;
}
interface Cuisine {
  uuid: UUID;
  name: string;
}
const ListReport = () => {
  const navigate = useNavigate();
  const { formatDateUS, formatTimeUS } = useFormattedUtils();
  const { currentUser } = useAuth();
  const tableRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [listReport, setReport] = useState<Orders[]>([]);
  const [orderStatus, setOrderStatus] = useState<OrderStatusList[]>([]);
  const [dish, setDish] = useState<Dish[]>([]);
  const [user, setUser] = useState<User[]>([]);
  const [cuisine, setCuisine] = useState<Cuisine[]>([]);
  const [category, setCategory] = useState<Category[]>([]);
  const [type, setType] = useState<Type[]>([]);
  const [cuisineId, setCuisineId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [dishId, setDishId] = useState("");
  const [userId, setUserId] = useState("");
  const [orderStatusId, setOrderStatusId] = useState("");
  const [search, setSearch] = useState("");
  const [selectedTypes, setSelectedTypes] = useState<Type[]>([]);
  // Removed the default values for fromDate and toDate
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // const [fromDate, setFromDate] = useState(
  //   new Date().toISOString().split("T")[0]
  // );
  // const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);

  const handleFromDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFromDate(e.target.value);
  };
  const handleToDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setToDate(e.target.value);
  };
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const filterData = {
    search: search,
    dishId: dishId,
    cuisineId: cuisineId,
    categoryId: categoryId,
    typeId: selectedTypes,
    orderstatusId: orderStatusId,
    userId: userId,
  };
  useEffect(() => {
    getReports(chefId, filterData).then((res) => {
      setReport(res?.data);
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    getDish()
      .then((res) => {
        setDish(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);
  useEffect(() => {
    getCategory()
      .then((res) => {
        setCategory(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);
  useEffect(() => {
    getCuisine()
      .then((res) => {
        setCuisine(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);
  useEffect(() => {
    getUser()
      .then((res) => {
        setUser(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);
  useEffect(() => {
    getType()
      .then((res) => {
        setType(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);
  useEffect(() => {
    getOrderStatus()
      .then((res) => {
        setOrderStatus(res?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, []);
  const handleCheckboxChange = (value: any) => {
    setSelectedTypes((prevSelectedTypes) =>
      prevSelectedTypes.includes(value)
        ? prevSelectedTypes.filter((type) => type !== value)
        : [...prevSelectedTypes, value]
    );
  };

  const clickApply = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setCurrentPage(1);
    const data = {
      search: search,
      orderstatusId: orderStatusId,
      userId: userId,
      dishId: dishId,
      cuisineId: cuisineId,
      categoryId: categoryId,
      typeId: selectedTypes,
    };
    try {
      await getReports(chefId, data).then((res) => {
        setReport(res?.data);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching coupon:", error);
      setLoading(false);
    }
  };

  const clickCancel = () => {
    navigate("/report");
  };

  const chefId = currentUser?.uuid;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = listReport.slice(indexOfFirstItem, indexOfLastItem);
  const pages = Math.ceil(listReport.length / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= pages; i++) {
    pageNumbers.push(i);
  }

  const pad = (n: any) => (n < 10 ? "0" + n : n);
  const DatefileName = new Date();
  const fileName =
    DatefileName.getFullYear() +
    "-" +
    pad(DatefileName.getMonth() + 1) +
    "-" +
    pad(DatefileName.getDate());
  // const DatefileName = new Date();
  // const fileName =
  //   DatefileName.getFullYear() +
  //   "-" +
  //   (DatefileName.getMonth() + 1) +
  //   "-" +
  //   DatefileName.getDate();

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: `chef_Report_${fileName}`,
    sheet: "Chefs",
  });

  const exportPDF = async () => {
  const element = document.getElementById("pdf-content");
  if (!element) return alert("Content not found!");

  // 👉 Temporarily show all data
  const originalMaxHeight = element.style.maxHeight;
  const originalOverflow = element.style.overflow;
  element.style.maxHeight = "none";
  element.style.overflow = "visible";

  await new Promise((res) => setTimeout(res, 300)); // wait for render

  const canvas = await html2canvas(element, { scale: 2 });
  const imgData = canvas.toDataURL("image/png");

  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgProps = pdf.getImageProperties(imgData);
  const imgHeight = (imgProps.height * pageWidth) / imgProps.width;

  let position = 0;

  while (position < imgHeight) {
    pdf.addImage(imgData, "PNG", 0, -position, pageWidth, imgHeight);
    position += pageHeight;
    if (position < imgHeight) pdf.addPage();
  }

  pdf.save(`chef_Report_${fileName}.pdf`);

  // 👉 Restore scrollable layout
  element.style.maxHeight = originalMaxHeight;
  element.style.overflow = originalOverflow;
};

  // const onPrint = () => {
  //   window.print(); // or your custom print logic
  // };

  const onPrint = () => {
    const tableContent = document.getElementById("pdf-content");

    if (!tableContent) {
      alert("Table not found for printing.");
      return;
    }

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
      <html>
        <head>
          <title>Print Table</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid #000;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f0f0f0;
            }
          </style>
        </head>
        <body>
          ${tableContent.innerHTML}
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  // Color mapping for status
  const statusColors: { [key: string]: string } = {
    "ordered": "black",
    "preparing": "orange",
    "ready": "blue",
    "track": "purple",
    "delivered": "green",
    "canceled": "red",
    "canceled by admin": "red",
    "failed": "grey",
    "canceled by user": "pink",
    "accepted ": "lightblue",
    "accepted driver": "lightgreen",
    "canceled by driver": "darkred",
    "On the way to user": "lightblue",
  };

  return (
    <>
      <section className="container-fluid">
        <div className="row">
          <section className="content-section">
            {/*  */}
            <section className="row main-content">
              <div className="title mb-3">
                <h3 className="mb-0">Report </h3>
              </div>

              <div className="col-12 title-btm">
                
        <SearchInput
                 value={search}
                     onChange={(e) => {
                        setSearch(e.target.value);
                      }}
                  onKeyUp={clickApply}
                  />

                <div className="col-md-4 d-flex align-items-center justify-content-end pt-4">
                  <div className="dropdown">
                    <button
                      className="btn btn-danger dropdown-toggle rounded-5 large"
                      type="button"
                      id="exportDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      onClick={onDownload}
                    >
                      <i className="fas fa-file-export me-2"></i>Export
                    </button>
                    <ul className="dropdown-menu" >
                      <li>
                        <button className="dropdown-item" onClick={onDownload}>
                          <i className="fas fa-file-excel text-success me-2"></i> Excel
                        </button>
                      </li>
                  
                      
                    </ul>
                  </div>
                </div>
              </div>

              <div className="filter-sec mt-4">
                <form
                  noValidate
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                    }
                  }}
                >
                  <div className="row gx-3">
                    <div className="col-md-2">
                      <label className="form-label">Cuisine</label>
                      <select
                        className="form-select form-control"
                        onChange={(e) => setCuisineId(e.target.value)}
                      >
                        <option value="">All</option>
                        {cuisine.map((item, i) => {
                          return (
                            <option value={item?.uuid} key={i}>
                              {item?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Category</label>
                      <select
                        className="form-select form-control"
                        onChange={(e) => setCategoryId(e.target.value)}
                      >
                        <option value="">All</option>
                        {category.map((item, i) => {
                          return (
                            <option value={item?.uuid} key={i}>
                              {item?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Dish</label>
                      <select
                        className="form-select form-control"
                        onChange={(e) => setDishId(e.target.value)}
                      >
                        <option value="">All</option>
                        {dish.map((item, i) => {
                          return (
                            <option value={item?.uuid} key={i}>
                              {item?.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="col-md-2">
                      <label className="form-label">Order Status</label>
                      <select
                        className="form-select form-control"
                        onChange={(e) => setOrderStatusId(e.target.value)}
                      >
                        <option value="">All</option>
                        {orderStatus.map((item, i) => {
                          return (
                            <option value={item?.id} key={i}>
                              {item?.name.replace(/\b\w/g, c => c.toUpperCase())}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Type</label>
                      {type.map((item: any, i) => {
                        return (
                          <div
                            className="form-check form-check-inline me-2 mt-2"
                            key={i}
                          >
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id={`inlineCheckbox${i + 1}`}
                              value={item?.uuid}
                              checked={selectedTypes.includes(item?.uuid)}
                              onChange={() => handleCheckboxChange(item?.uuid)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`inlineCheckbox${i + 1}`}
                            >
                              {item?.name}
                            </label>
                          </div>
                        );
                      })}
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">User</label>
                      <select
                        className="form-select form-control"
                        onChange={(e) => setUserId(e.target.value)}
                      >
                        <option value="">All</option>
                        {user.map((item, i) => {
                          return (
                            <option value={item?.uuid} key={i}>
                              {item?.userName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={handleFromDateChange}
                      />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={handleToDateChange}
                      />
                    </div>
                    <div className="col-md-4 d-flex align-items-center justify-content-end pt-4">
                      <button
                        className="btn btn-cancel rounded-5 small me-2 mt-1"
                        onClick={clickCancel}
                      >
                        Clear
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary rounded-5 small mt-1 clickedbutton"
                        onClick={clickApply}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <div id="pdf-content">
                <div className="table-wrap mt-4">
                  <table className="table custom-table" ref={tableRef}>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th className="text-green">Order Id</th>
                        <th>User Name</th>
                        <th>Dishes</th>
                        <th>Type</th>
                        <th>Category</th>
                        <th>Cuisine</th>
                        <th>Total Amount ($)</th>
                        <th>Rating</th>
                        <th>Order Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems?.length > 0 ? (
                        currentItems?.map((item, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td className="text-warnings">{item?.orderId}</td>
                            <td>
                              {item?.user?.name} <br />(
                              {item?.user?.contactNumber})
                            </td>
                            <td>
                              {item?.orderdetails.map((detail, j) => (
                                <div key={j} className="dish-details">
                                  <p>
                                    {detail?.dish?.name} * {detail?.quantity}
                                  </p>
                                </div>
                              ))}
                            </td>
                            <td>
                              {item?.orderdetails.map((detail, j) => (
                                <div key={j} className="dish-details">
                                  <p>{detail?.dish?.type?.name}</p>
                                </div>
                              ))}
                            </td>

                            <td>
                              {item?.orderdetails.map((detail, j) => (
                                <div key={j} className="dish-details">
                                  <p>{detail?.dish?.category?.name}</p>
                                </div>
                              ))}
                            </td>
                            <td>
                              {item?.orderdetails.map((detail, j) => (
                                <div key={j} className="dish-details">
                                  <p>{detail?.dish?.cuisine?.name}</p>
                                </div>
                              ))}
                            </td>
                            <td>$
                              {(
                                item?.amount +
                                item?.chefTips +
                                item?.tax -
                                (item?.couponAmount || 0)
                              ).toFixed(2)}</td>
                            <td>
                              <span className="rating">
                                <img
                                  src="/assets/images/star.svg"
                                  alt="Rating"
                                />
                                0{/* You may replace 0 with the actual rating */}
                              </span>
                            </td>
                            <td>
                              {formatDateUS(item?.orderDate)} - {formatTimeUS(item?.orderDate)}
                            </td>
                            <td
                              className="fw-bold "
                              style={{
                                color: statusColors[item?.orderstatus?.name || ""],
                              }}>
                              {item?.orderstatus?.name
                                ? item.orderstatus.name.replace(/\b\w/g, c => c.toUpperCase())
                                : "Unknown"}
                            </td>
                          </tr>
                        ))
                      ) : loading ? (
                        <tr>
                          <td colSpan={11} className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan={11} className="text-center">
                            No Reports Available at the Moment.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <Pagination
                data={listReport}
                indexOfFirstItem={indexOfFirstItem}
                indexOfLastItem={indexOfLastItem}
                currentItems={currentItems}
                pages={pages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageNumbers={pageNumbers}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
              />
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default ListReport;